// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { message } from 'antd';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}


/** 获取规则列表 GET /api/rule */
export async function rulepro(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleProList>('/api/rulepro', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}


/** 获取规则列表 GET /api/rulepro/faka */
export async function RuleFaka(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleProList>('/api/rulepro/faka', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rulepro/URL */
export async function RuleURL(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleProList>('/api/rulepro/URL', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rulepro/URL */
export async function RuleTelegram(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleProList>('/api/rulepro/Telegram', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取 IP_Data 资产测绘列表 GET /api/rulepro/fofa */
export async function getIPData(
  params: {
    url?: string;
    ip?: string;
    tag?: string;
    name?: string;
    current?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.IPDataList>('/api/rulepro/fofa', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule/', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}


/** 获取 AiKey 列表 GET /api/rulepro/aikey */
export async function AiKeyList(
  params: {
    name?: string;
    type?: string;
    baseURL?: string;
    mode?: string;
    status?: string;
    source?: string;
    current?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.AiKeyList>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 添加 AiKey POST /api/rulepro/aikey */
export async function AiKeyAdd(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'add',
      ...(options || {}),
    },
  });
}

/** 删除 AiKey POST /api/rulepro/aikey */
export async function AiKeyRemove(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 获取 AiKey 类型列表 POST /api/rulepro/aikey */
export async function AiKeyType() {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'type',
    },
  });
}

/** 拉取上游模型列表（GET {baseURL}/models） POST /api/rulepro/aikey */
export async function AiKeyModels(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'models',
      ...(options || {}),
    },
  });
}

/** 测试 AiKey POST /api/rulepro/aikey */
export async function AiKeyTest(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'test',
      ...(options || {}),
    },
  });
}

/** 批量测试 AiKey 模型是否有效 POST /api/rulepro/aikey */
export async function AiKeyBatchTest(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'batchtest',
      ...(options || {}),
    },
  });
}

/** 批量获取勾选 AiKey 的上游模型列表并写回 mode POST /api/rulepro/aikey */
export async function AiKeyBatchModels(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'batchmodels',
      ...(options || {}),
    },
  });
}

/** 查询勾选 AiKey 的上游余额 POST /api/rulepro/aikey */
export async function AiKeyBalance(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'balance',
      ...(options || {}),
    },
  });
}

/** 推送 AiKey POST /api/rulepro/aikey */
export async function AiKeyPush(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'push',
      ...(options || {}),
    },
  });
}

/** 更新 AiKey（修改模型列表等） POST /api/rulepro/aikey */
export async function AiKeyUpdate(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${getBaseURL()}/api/rulepro/aikey`, {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 获取规则列表 GET /api/rulepro/IP_proxy */
export async function RuleIP(
  params: {
    // query
    name?:string
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    sortField?: string;   // 新增
    sortOrder?: string;   // 新增，'asc' | 'desc'
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleProList>('/api/rulepro/IP_proxy', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取谷歌账号列表 GET /api/rulepro/Google */
export async function RuleGoogle(
  params: {
    email?: string;
    password?: string;
    twofa?: string;
    recovery?: string;
    year?: string;
    status?: string;
    tag?: string;
    time?: string[];
    current?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.GoogleList>('/api/rulepro/Google', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 谷歌账号操作（add 导入 / status 改状态 / delete 删除） POST /api/rulepro/Google */
export async function GoogleAction(options: { [key: string]: any }, method: string) {
  return request<Record<string, any>>('/api/rulepro/Google', {
    method: 'POST',
    data: {
      method,
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRulePro(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rulepro/', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}


/** 删除规则 DELETE /api/rule */
export async function QuerySSR(res: any | undefined,method?:string) {
  return request<Record<string, any>>('/api/rule/', {
    method: 'POST',
    data: {
      method: method,
      key: res.key,
      ip: res.ip,
    },
  });
}

/** 新建规则 POST /api/rule */
export async function apiconfig() {
  return request<API.config>('/api/out', {
    method: 'POST',
    data: {
      method: 'config',
      ...(Option || {}),
    },
  });
}


// config.ts（或者直接放在 app.ts 中）
export function getBaseURL(): string {
  if (process.env.NODE_ENV === 'development') {
    return "";
  } else if (process.env.NODE_ENV === 'production') {
    return 'https://api.101060.xyz';
  } else {
    return 'https://api.101060.xyz'; // 默认用生产环境
  }
}

// 复制订阅
export function handleCopy(texts: string) {
  if (!texts) {
    message.warning('无可复制内容');
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(texts).then(() => {
      message.success('复制成功');
    }).catch(() => {
      message.error('复制失败');
    });
  } else {
    message.error('当前浏览器不支持 Clipboard API');
  }
};

/** 获取操作日志列表 GET /api/log */
export async function getLogList(
  params: {
    time?: string;
    user?: string;
    action?: string;
    module?: string;
    current?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.LogList>('/api/log', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取监控首页概览数据 POST /api/dashboard */
export async function getDashboard(options?: { [key: string]: any }) {
  return request<{
    success?: boolean;
    data?: API.DashboardData;
    message?: string;
  }>('/api/dashboard', {
    method: 'POST',
    data: { method: 'overview' },
    ...(options || {}),
  });
}
